export default {
    fund: [{
            "title": "在股票和期货市场中常设有一类投资者，对市场上所有的股票，每一只都少量购买甚至只买一手，业内称为股票集邮投资者或者股票收藏投资者，这类投资者的投资方法体现了其分散投资和被动投资管理的策略。哪一类基金的出现，使得这类投资者的想法得以更好的实现（　　）。",
            "question": "A. 混合基金\nB. QDII基金\nC. 股票型指数基金\nD. 灵活配置型基金",
            "answer": "C",
            "explain": "本题考查股票型指数基金的概念。A选项不符合题意，混合基金是指同时投资于股票、债券和货币市场等工具，没有明确的投资方向的基金。B选项不符合题意，QDII基金是在一国境内设立，经该国有关部门批准从事境外证券市场的股票、债券等有价证券业务的证券投资基金。C选项符合题意，股票型指数基金是以特定的股指为标的指数，并以该指数的成份股为投资对象，通过购买该指数的全部或部分成份股构建投资组合，以追踪标的指数表现的基金产品。"
        },
        {
            "title": "在企业财务报表项目中，表示企业所有者权益的，以及被其他企业所欠的各种资源或财产的是（　　）。",
            "question": "A. 资产\nB. 所有者权益\nC. 负债\nD. 净利润",
            "answer": "A",
            "explain": "本题考查资产的概念。资产负债表中的资产部分表示企业所拥有或掌控的，以及被其他企业所欠的各种资源或财产。"
        },
        {
            "title": "关于做市商与经纪人的相同点和区别，以下表述错误的是（　　）。",
            "question": "A. 一般情况下，做市商参与交易，经纪人不参与交易\nB. 做市商的利润主要来自于证券买卖差价，经纪人的利润主要来自于交易佣金\nC. 经纪人可以为做市商服务\nD. 经纪人能为市场提供流动性，做市商不能",
            "answer": "D",
            "explain": "本题考查做市商与经纪人的区别。A选项表述正确，做市商在报价驱动市场中处于关键性地位，与投资者进行买卖双向交易。经纪人在交易中执行投资者的指令，并没有参与到交易中。B选项表述正确，做市商的利润来自于证券买卖差价，如果差价太大，做市商将很难促成交易，从而失去赚取差价的机会，如果证券差价小但交易频繁，做市商仍可以赚取利润。经纪人的利润来自于给投资者提供经纪业务的佣金。"
        },
        {
            "title": "有4家上市公司，过去5年的净利润增长率均值都为9%，则增长最稳定的公司是（　　）。",
            "question": "A. 5年净利润增长率标准差为3.0%的公司\nB. 5年净利润增长率标准差为1.8%的公司\nC. 5年净利润增长率标准差为2.9%的公司\nD. 5年净利润增长率标准差为1.7%的公司",
            "answer": "D",
            "explain": "本题考查方差和标准差的概念。对于投资收益率，用方差或者标准差来衡量它偏离期望值的程度。数值越大，表示收益率偏离期望收益率的程度越大;反之亦然。"
        },
        {
            "title": "按照全球投资业绩标准(GIPS)的要求，组合群收益的计算方式为组合群中所有投资组合收益的（　　）。",
            "question": "A. 资产加权平均\nB. 中位数\nC. 算术平均\nD. 几何平均",
            "answer": "A",
            "explain": "本题考查组合群收益的计算。自2006年1月1日起，投资管理机构必须至少每季度次计算组合群的收益，并使用个别投资组合的收益以资产加权计算。自2010年1月1日起，必须至少每月一次计算组合群收益，并使用个别投资组合的收益以资产加权计算。"
        },
        {
            "title": "关于战术资产配置，以下表述正确的是（　　）。",
            "question": "A. 战术资产配置在调整资产配置时，需要再次估计投资者偏好与风险承担能力\nB. 战术资产配置通过捕捉各类资产的短期回报率波动增加投资组合回报率\nC. 战术资产配置的有效性不存在争议\nD. 战术资产配置是对战略资产配置的短期完全偏离",
            "answer": "B",
            "explain": "本题考查战术资产配置。A选项错误，战术资产配置在调整资产配置时，没有再次估计投资者偏好和风险承受能力或投资目标是否发生了变化；B选项正确，战术资产配置通过捕捉各类资产的短期回报率波动，增强投资组合回报率；C选项错误，战术资产配置的有效性是存在争议的，实践证明只有少数基金管理人能够通过择时得到超额收益；D选项错误，战术资产配置对战略资产配置的偏离往往被限制在一定范围内。"
        }, {
            "title": "某基金的年化收益率为35%，年化标准差为28%，假设收益率符合标准正态分布，该基金年度收益率在67%的概率下处于如下区间（　　）。",
            "question": "A. 70%~35%\nB. 28%~38%\nC. 28%~35%\nD. 63%~7%",
            "answer": "D",
            "explain": "本题考查股票基金的风险指标——标准差。在净值增长率服从正态分布时，基金收益率落入平均值正负1个标准差范围内的概率是2/3(约67%)。根据题意可得，该基金年度收益率在67%的概率下处于区间63%(35%+28%)~7%(35%-28%)，D项符合题意。"
        },
        {
            "title": "某零息债券面额为100元，内在价值为90.70元，到期期限为2年，则市场的贴现率为（　　）。",
            "question": "A. 5.5%\nB. 4.5%\nC. 4.0%\nD. 5.0%",
            "answer": "D",
            "explain": "本题考查零息债券估值方法。零息债券内在价值的计算公式为：V=M/(1+r)^n，将题中数值代入公式，求解表达式90.70=100/(1+r)^2，得出r=5.0%。"
        },
        {
            "title": "在给定的时间区间和置信区间内，投资组合损失的期望被称为（　　）。",
            "question": "A. 下行标准差\nB. 风险价值\nC. 最大回撤\nD. 预期损失",
            "answer": "D",
            "explain": "本题考查预期损失的概念。A选项不符合题意，下行标准差是用来测量收益率不达目标时的风险。B选项不符合题意，风险价值又称在险价值、风险收益、风险报酬，是指在给定的时间区间内和置信水平下，利率、汇率等市场风险要素发生变化时，投资组合所面临的潜在最大损失。"
        },
        {
            "title": "关于期货合约，以下表述错误的是（　　）。",
            "question": "A. 盯市制度对保证期货合约的履行非常重要\nB. 期货合约是非标准化合约\nC. 投机者是期货市场的重要组成部分\nD. 金融期货合约的交割大多采用现金结算",
            "answer": "B",
            "explain": "本题考查期货合约的概念。A选项表述正确，盯市是为了避免因发生违约而导致另一方当事人蒙受巨大损失而设计的，它对于保证期货合约的履行是至关重要的。B选项表述错误，期货合约指交易双方签署的在未来某个确定的时间按确定的价格买入或卖出某项合约标的资产的合约，其是标准化合约。C选项表述正确，投机者是期货市场的重要组成部分，是期货市场必不可少的润滑剂。D选项表述正确，有些金融期货合约的标的资产不方便或不可能进行有形交割，只能以现金结算。综上所述，ACD选项表述正确，B选项表述错误。"
        },
        {
            "title": "如果要将基于每日收益率计算所得的下行标准差进行年化，正确的做法是（　　）。",
            "question": "A. 除以交易日数量的开方\nB. 乘以交易日数量\nC. 乘以交易日数量的开方\nD. 除以交易日数量",
            "answer": "C",
            "explain": "本题考查下行标准差的年化处理。在对下行标准差进行年化处理时，如果收益率采用每日收益，则乘以交易日数量的开方；如果收益率采用每月收益，则乘以12的开方。本题中，在基于每日收益率对下行标准差进行年化处理时，则需乘以交易日数量的开方，C选项符合题意。"
        },
        {
            "title": "质押式回购期间发生质押券的孳息，利息归（　　）。",
            "question": "A. 融券方\nB. 正回购方\nC. 逆回购方\nD. 双方协商",
            "answer": "B",
            "explain": "本题考查银行间债券市场的交易品种。质押式回购是指质押的国债的所有权仍属于国债的出让方(正回购方)，受让方(逆回购方)无权处置，国债被证券交易中心冻结，回购期间的利息属于正回购方，B选项符合题意。"
        }, {
            "title": "关于债权人与股权持有者利润分配的规定，正确的是（　　）。",
            "question": "A. 企业盈利时，债权人只能按约定比例参与企业利润的分配\nB. 企业破产时，股权持有者优先于债券持有人获得企业资产的清偿\nC. 企业盈利时，债权人劣后于股权持有者获得企业利润的分配\nD. 企业破产时，债权人优先于股权持有者获得企业资产的清偿",
            "answer": "D",
            "explain": "本题考查债权人与股权持有者利润分配的规定。A、C选项说法错误，债权资本是通过借债方式筹集的资本，债权人获得固定利息且利息的高低与公司经营的风险相关。企业盈利时，债权人优先于(并非劣后于)股权持有者获得企业利润的分配。B选项说法错误，D选项说法正确，债权资本是一种借入资本，代表了公司的合约义务，因此债券持有者/债权人拥有公司资产的最高索取权，股权持有者劣后于(并非优先于)债券持有人获得企业资产的清偿。"
        },
        {
            "title": "战术资产配置在动态调整资产配置时，需要（　　）。",
            "question": "A. 再次估计投资者偏好\nB. 重新设定投资者长远投资目标\nC. 再次估计投资者风险承受能力\nD. 重新预测不同资产类别的预期收益情况",
            "answer": "D",
            "explain": "本题考查战术资产配置的概念。战术资产配置是一种根据对短期资本市场环境及经济条件的预测、积极、主动地对资产配置状态进行动态调整，从而增加投资组合价值的积极战略。与战略资产配置相比，战术资产配置在动态调整资产配置时，需要重新预测不同资产类别的预期收益情况(D选项符合题意)，但没有再次估计投资者偏好与风险承受能力或投资目标是否发生了变化(A、B、C选项不符合题意)。"
        },
        {
            "title": "投资衍生工具的风险包括（　　）。",
            "questions": "I. 交易双方中的某方违约的违约风险<br>II. 资产价格波动导致损失的价格风险<br>III. 缺少交易对手而不能平仓或变现的流动性风险<br>IV. 人为错误或系统故障导致的运作风险",
            "question": "A. I、II、III\nB. II、III、IV\nC. I、II、III、IV\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查衍生工具的风险。衍生工具具有以下风险：I. 交易双方中的某方违约的违约风险；II. 资产价格波动导致损失的价格风险；III. 缺少交易对手而不能平仓或变现的流动性风险；IV. 人为错误或系统故障导致的运作风险。"
        },
        {
            "title": "关于市场有效性，以下说法错误的是（　　）。",
            "question": "A. 在弱有效市场下，任何为了预测未来证券价格走势而面对历史价格，成交量等信息所进行的技术分析都是徒劳的\nB. 在强有效市场上，任何投资者不管采用何种分析方法，都不可能重复的、更不可能连续地取得成功\nC. 强有效市场意味着那些拥有“内部信息”的市场参与者也不能凭借该信息获得超额收益\nD. 半强有效市场下，价格对公开信息的反应是瞬间完成的",
            "answer": "D",
            "explain": "本题考查三种有效市场的特点。A选项说法正确，弱有效市场是指证券价格能够充分反映价格历史序列中包含的所有信息，如证券的价格、交易量等，任何为了预测未来证券价格走势而对以往价格、交易量等历史信息所进行的技术分析都是徒劳的。B、C选项说法正确，强有效市场是指与证券有关的所有信息，包括公开发布的信息和未公开发布的内部信息，都已经充分，及时地反映到了证券价格之中，任何投资者不管采用何种分析方法，除了偶尔靠运气“预测”到证券价格的变化外，是不可能重复地，更不可能连续地取得成功的。"
        },
        {
            "title": "“利滚利”所指的计息方式为（　　）。",
            "question": "A. 单利\nB. 复利\nC. 单利和复利\nD. 单利或复利",
            "answer": "B",
            "explain": "本题考查复利的概念。单利是本金在计息周期中获得的利息，无论时间多长，均不加入本金重复计算利息。复利是要将所生利息加入本金再计利息，即利滚利。B选项符合题意。"
        },
        {
            "title": "关于通过构建投资组合来分散风险的效果，以下说法正确的是（　　）。",
            "question": "A. 系统性风险和非系统性风险都不可能被分散\nB. 可以分散非系统性风险\nC. 系统性风险和非系统性风险均需被完全分散\nD. 可以分散系统性风险",
            "answer": "B",
            "explain": "本题考查风险分散化。系统性风险是指在一定程度上无法通过一定范围内的分散化投资来降低的风险；非系统性风险是可以通过构造资产组合分散掉的风险。综上所述，B选项符合题意。"
        }, {
            "title": "（　　）是由中央银行发行的用于调节商业银行超额准备金的短期债务凭证。",
            "question": "A. 中央银行票据\nB. 银行承兑汇票\nC. 短期国债\nD. 商业票据",
            "answer": "A",
            "explain": "本题考查中央银行票据的概念。A选项符合题意，中央银行票据是由中央银行发行的用于调节商业银行超额准备金的短期债务凭证，简称央行票据或央票。B选项不符合题意，银行承兑汇票是由在承兑银行开立存款账户的存款人出票，向开户银行申请并经银行审查同意承兑的，保证在指定日期无条件支付确定的金额给收款人或持票人的票据，是商业票据的一种。C选项不符合题意，短期国债是一国政府为满足先支后收所产生的临时性资金需要而发行的短期债券。D选项不符合题意，商业票据指发行主体为满足流动资金的需求所发行的期限为2天至270天的，可流通转让的债务工具。综上所述，B、C、D选项不符合题意，A选项符合题意。"
        },
        {
            "title": "下列关于固定利率债券的说法中，错误的是（　　）。",
            "question": "A. 固定利率债券是政府和企业发行的主要债券种类\nB. 固定利率债券到期日并不固定\nC. 固定利率债券在偿还期内有固定的票面利率和不变的面值\nD. 通常，固定利率债券在偿还期内定期支付利息，并在到期日支付面值",
            "answer": "B",
            "explain": "本题考查固定利率债券的概念。A、C选项说法正确，B选项说法错误，固定利率债券是由政府和企业发行的主要债券种类，有固定的到期日（并非到期日不固定），并在偿还期内有固定的票面利率和不变的面值。D选项说法正确，通常，固定利率债券在偿还期内定期支付利息，并在到期日支付面值。综上所述，A、C、D选项说法正确，B选项说法错误。"
        },
        {
            "title": "资本市场理论的前提假设可以归结为（　　）。",
            "questions": "I. 所有投资者都是一样的<br>II. 市场是有效的<br>III. 投资者的投资期限由其财富总额决定<br>IV. 金融交易涉及交易费用且不存在税收负担",
            "question": "A. I、II、III、IV\nB. I、II\nC. I、III\nD. II、IV",
            "answer": "B",
            "explain": "本题考查资本市场理论的前提假设。资本市场理论的七条前提假设可以归结为两条：一是所有投资者都是一样的，二是市场是有效的。"
        },
        {
            "title": "所有境外投资者对单个上市公司A股的持股比例总和，不得超过该上市公司股份总数的（　　）。",
            "question": "A. 10%\nB. 20%\nC. 30%\nD. 40%",
            "answer": "C",
            "explain": "本题考查QFII的概念、规则和发展概况。单个境外投资者对单个上市公司A股的持股比例总和，不超过该上市公司股份总数的10%，所有境外投资者对单个上市公司A股的持股比例总和，不超过该上市公司股份总数的30%。"
        },
        {
            "title": "关于风险指标，以下表述正确的是（　　）。",
            "question": "A. 损失是一个事前概念\nB. 损失是一个事后概念\nC. 风险是一个事后概念\nD. 事后指标通常用来衡量和预测目前组合在将来的表现和风险情况",
            "answer": "B",
            "explain": "本题考查风险测度的事前和事后指标。A选项表述错误，B选项表述正确，事后指标通常用来评价一个组合在历史上的表现和风险情况，常用来测度风险调整后的收益情况。损失属于事后指标。C、D选项表述错误，事前指标（并非事后指标）通常用来衡量和预测目前组合在将来的表现和风险情况。风险属于事前指标。"
        },
        {
            "title": "以下各类股票估值方法中，不含相对估值法的选项是（　　）。",
            "question": "A. 股利贴现模型，经济附加值模型，自由现金流贴现模型\nB. 股利贴现模型，企业价值倍数，经济附加值模型\nC. 股利贴现模型，经济附加值模型，市销率模型\nD. 股利贴现模型，企业价值倍数，市盈率模型",
            "answer": "A",
            "explain": "本题考查内在价值法。内在价值法又称绝对价值法或收益贴现模型，是按照未来现金流的贴现对公司的内在价值进行评估。具体分为股利贴现模型、自由现金流贴现模型、经济附加值模型，相对估值法包括市盈率模型、市净率模型、企业价值倍数、市现率模型、市销率模型。综上所述，A选项符合题意。"
        }, {
            "title": "下列不属于法玛界定的有效市场类别的是（　　）。",
            "question": "A. 弱有效\nB. 强有效\nC. 半弱有效\nD. 半强有效",
            "answer": "C",
            "explain": "本题考查有效市场的类型。法玛根据市场中包含的信息种类，将市场分为：(1)强有效市场，是指与证券有关的所有信息，包括公开发布的信息和未公开发布的内部信息，都已经充分、及时地反映到了证券价格之中。(2)半强有效市场，是指证券价格不仅已经反映了历史价格信息，而且反映了当前所有与公司证券有关的公开有效信息。(3)弱有效市场，是指证券价格能够充分反映价格历史序列中包含的所有信息，如证券的价格、交易量等。A、B、D选项属于有效市场，不符合题意，C选项“半部有效市场”，无该名词，符合题意。"
        },
        {
            "title": "关于常用的VAR估算方法---历史模拟法，以下表述正确的是（　　）。",
            "question": "A. 历史模拟法假设风险因子收益率服从某特定类型的概率分布，依据历史数据计算出风险因子收益率分布的参数值\nB. 历史模拟法事先确定风险因子收益或概率分布，利用历史数据对未来方向进行估算\nC. 历史模拟法通过风险因子的概率分布模型，框而重复模拟风险因子变动的过程\nD. 历史模拟法可以模拟历史样本分布求出风险价值，组合收益的数据可以利用组合中投资工具收益的历史数据求得",
            "answer": "D",
            "explain": "本题考查历史模拟法的概念。A选项表述错误，假设风险因子收益率服从某特定类型的概率分布，依据历史数据计算出风险因子收益率分布的参数值这是参数法。B选项表述错误，历史模拟法非常简单，因为该种方法无须在事先确定风险因子收益或概率分布，只需利用历史数据对未来方向进行估算。C选项表述错误，D选项表述正确，历史模拟法根据风险因子收益的近期历史数据的估算，模拟出未来的风险因子收益变化。"
        },
        {
            "title": "以下属于基金公司在交易执行环节可能存在的操作风险是（　　）。",
            "questions": "I. 市场利率变动导致基金价值变动<br>II. 交易员不能有效履行对基金经理交易指令的监督、复核职责<br>III. 交易系统缺陷造成交易失误<br>IV. 面临巨额赎回，被迫以不适当价格大量卖出股票或债券",
            "question": "A. II、III\nB. II、III、IV\nC. I、IV\nD. I、II、III、IV",
            "answer": "A",
            "explain": "本题考查基金投资交易过程中的操作风险。"
        },
        {
            "title": "在基金的净值过低时，管理人通过基金份额的合并可以提高基金的净值，这种行为通常又称（　　）。",
            "question": "A. 逆向分拆\nB. 逆向合并\nC. 正向分拆\nD. 正向合并",
            "answer": "A",
            "explain": "本题考查逆向分拆的概念。A选项符合题意，在基金的净值过低时，管理人通过基金份额的合并可以提高基金的净值，这种行为通常称为逆向分拆，B、C、D选项不符合题意，没有逆向合并。正向分拆和正向合并的称谓。"
        },
        {
            "title": "一份当前签署的，距到期日两年的远期合约，如果标的资产目前的价格为100元，市场无风险连续复利利率为10%，则该标的资产理论上的远期价格为（　　）。",
            "question": "A. 122.1元\nB. 90.48元\nC. 110.5元\nD. 81.87元",
            "answer": "A",
            "explain": "本题考查远期合约的定价。远期合约的远期价格的计算公式为：F=S0*e^(r*T)，式中，F表示远期价格；S0表示标的资产当前的现货价格；r表示无风险利率；T表示到期日。本题中，S0=100，r=10%，T=2，e=2.7182，代入公式得：F=100*2.7182^(0.1*2)≈122.1元。"
        },
        {
            "title": "以下交易采用净额结算方式的是（　　）。",
            "question": "A. 跨境ETF申购\nB. 股票买卖\nC. 私募债券转让\nD. 大宗交易",
            "answer": "B",
            "explain": "本题考查证券交易的结算方式。净额结算又称差额清算，指在一个清算期中，对每个结算参与人价款的清算只计其各笔应收、应付款项相抵后的净额，对证券的清算只计每一种证券应收、应付相抵后的净额。一般情况下，通过证券交易所达成的交易采用此种方法。股票买卖一般通过证券交易所达成交易，B选项符合题意。A、C、D选项中的交易一般采用全额结算，不符合题意。"
        }, {
            "title": "与证券市场的其他投资工具一样，债券投资也面临一系列风险，对于在市场利率下行的环境中，附息债券收回的利息或者提前于到期日收回的本金只能以低于原债券到期收益率的利率水平再投资于相同属性的债券，这种情况下产生的风险属于以下哪一项风险（　　）。",
            "question": "A. 流动性风险\nB. 投资收益风险\nC. 再投资风险\nD. 提前赎回风险",
            "answer": "C",
            "explain": "本题考查再投资风险的概念。A选项不符合题意，债券的流动性风险是指未到期债券的持有者无法以市值，而只能以期限低于市值的价格变现债券形成的投资风险。题干中所描述的情况不属于流动性风险。B选项不符合题意，不存在“投资收益风险”的称谓。"
        },
        {
            "title": "关于土地投资，以下表述正确的是（　　）。",
            "question": "A. 土地投资只能通过买卖差价来获取投资收益\nB. 土地投资价值受宏观环境和法律法规因素影响很小\nC. 基于未被开发这一特征，土地本身的不确定性非常高，土地投资可能具有较高投机性\nD. 土地投资只能通过出租来获取投资收益",
            "answer": "C",
            "explain": "本题考查土地投资的特点。A、D选项表述错误，土地投资可以通过买卖价差和出租等方式获取投资收益。B选项表述错误，土地投资可能具有较高的投机性，且由于其投资价值受到宏观环境和法律法规因素影响较大而极具风险性。C选项表述正确，地产亦指土地，是指未被开发的，可作为未来开发房地产基础的商业地产之一。土地本身的不确定性非常高，因此可能具有较高的投机性。"
        },
        {
            "title": "马科维茨1952年开创的投资理论的基础是（　　）。",
            "question": "A. 套利定价理论\nB. 单因子模型\nC. 均值---方差模型\nD. 资本资产定价模型",
            "answer": "C",
            "explain": "本题考查现代投资组合理论。1952年，哈里马科维茨在《金融杂志》上发表的文章《资产组合的选择》，首次提出了均值---方差模型，奠定了投资组合理论的基础，标志着现代投资组合理论(MPT)的开端，C选项符合题意。"
        },
        {
            "title": "某公司有两只基金，债券基金A和股票基金B，前一日A基金资产净值是100亿，当日基金资产净值为99亿，A基金的年管理费率为0.75%；B基金前一日基金资产净值是50亿，当日基金资产净值为52亿，B基金的年管理费率为1.5%，当年天数365天，则当日A基金和B基金计提的管理费（　　）。",
            "question": "A. 相同\nB. 无法确定\nC. A基金计提的管理费多于B\nD. B基金计提的管理费多于A",
            "answer": "A",
            "explain": "本题考查基金管理费计提标准。目前我国的基金管理费、基金托管费及基金销售服务费均是按前一日基金资产净值的一定比例逐日计提，按月支付。计算方法如下：H=(E×R)/当年实际天数，式中：H表示每日计提的费用；E表示前一日的基金资产净值；R表示年费率。则：A基金当日计提管理费用=(100×0.75%)/365=0.00205亿元；B基金当日计提管理费用=(50×1.5%)/365=0.00205亿元。"
        },
        {
            "title": "某公募基金管理公司计划发行QDII基金产品，开展海外证券投资业务，该公司内部开会讨论，列举了一些准备事项，在不考虑该公司自身状况的情况下，不属于必要事项的是（　　）。",
            "question": "A. 寻找境外投资顾问\nB. 寻找境内资产托管人并开立托管账户\nC. 向国家外汇管理局申请证券投资额度\nD. 向中国证监会申请境外证券投资业务许可",
            "answer": "A",
            "explain": "本题考查基金公司进行境外证券投资的交易与结算。境内机构投资者在获得中国证监会颁发的境外证券投资业务许可文件后，应按照有关规定向国家外汇管理局申请境外证券投资额度，并在国家外汇管理局核准的境外证券投资额度内进行投资。境内机构投资者应当在托管人处开立托管账户，托管基金、集合计划的全部资产。托管人应当为基金、集合计划开立结算账户和证券托管账户，用于与证券登记结算等机构之间的资金结算业务和证券托管业务。"
        },
        {
            "title": "关于债券信用风险的知识，以下表述错误的是（　　）。",
            "questions": "I. “11超日债”是国内一起标志性债券违约事件<br>II. 投资级债券也可被称为高收益债券<br>III. 我国的债券信用评级行业始于1987年<br>IV. 穆迪是三大国际信用评级机构之一",
            "question": "A. II\nB. I、IV\nC. III\nD. I、III",
            "answer": "A",
            "explain": "本题考查投资债券的信用风险。I项说法正确，“11超日债”是国内首例违约债券，表明我国债务“零违约”被正式打破；II项说法错误，投资级债券和高收益债券是两类不同的债券，投资级债券是指信用评级较高的债券，而高收益债券通常指信用评级较低但收益率较高的债券；III项说法正确，我国的债券信用评级行业始于1987年；IV项说法正确，穆迪是三大国际信用评级机构之一。"
        }, {
            "title": "2018年4月，港交所放行同股不同权。对于某些大型科技公司，需要不断再融资，但创始人的股权可能会不断地被摊薄，而这些创始人又是核心人物，不愿失去控制权。此次同股不同权改革针对的就是这类公司。“同股不同权”中的“权”在这个语境下是指（　　）。",
            "question": "A. 分红权\nB. 投票权\nC. 知情权\nD. 清偿权",
            "answer": "B",
            "explain": "本题考查同股不同权。“同股不同权”，又称“双层股权结构”，是指资本结构中包含两类或多类不同投票权的普通股架构。同股不同权为“AB股结构”，A类股一般由管理层持有，而管理层普遍为始创股东及其团队，B类股一般为外围股东持有，此类股东看好公司前景，因此甘愿牺牲一定的表决权作为入股筹码。同股不同权中的“权”在这个语境下是指投票权，B选项符合题意。"
        },
        {
            "title": "基金资产估值的第一责任主体是（　　）。",
            "question": "A. 基金托管人\nB. 基金管理人\nC. 基金投资者\nD. 基金分额登记机构",
            "answer": "B",
            "explain": "本题考查基金估值的法律依据。基金估值主体在现有基金法律体系中是完备的，无论是《证券投资基金法》还是中国证监会关于基金合同的格式要求、基金估值业务规定等都明确规定，基金管理人是基金估值的第一责任主体。"
        },
        {
            "title": "某统一公债的固定利息是50元，假定市场贴现率固定为5%，则该统一公债的内在价值为（　　）。",
            "question": "A. 1150元\nB. 1050元\nC. 1100元\nD. 1000元",
            "answer": "D",
            "explain": "本题考查统一公债的内在价值。统一公债的内在价值的计算公式为：V=C/r，式中，C表示每期支付的利息，r表示市场利率。本题中固定利息是50元，市场贴现率固定为5%。将数值代入公式可得，V=50/5%=1000(元)。"
        },
        {
            "title": "资本市场线采用（　　）来衡量风险。",
            "question": "A. 相关系数\nB. 标准差\nC. 斜率\nD. B值",
            "answer": "B",
            "explain": "本题考查资本市场线的概述。资本市场线实际上指出了有效投资组合风险与预期收益率之间的关系，提供了衡量有效投资组合风险的方法。资本市场线采用标准差来衡量风险。"
        },
        {
            "title": "关于证券交易所，以下描述正确的是（　　）。",
            "question": "A. 证券交易所提供交易场所和服务人员，以便利证券交易商的交易与交割\nB. 证券交易所本身不持有证券，也不进行证券的买卖\nC. 证券交易所的设立和解散，由国务院证券监督管理机构决定\nD. 证券交易所的理事会负责日常事项",
            "answer": "B",
            "explain": "本题考查证券交易所。A选项描述错误，证券交易所是为证券集中交易提供场所和设施，组织和监督证券交易，实行自律管理的法人。B选项描述正确，证券交易所作为进行证券交易的场所，其本身不持有证券，也不进行证券的买卖。"
        },
        {
            "title": "以下交易中，债券的所有权没有发生转移的是（　　）。",
            "question": "A. 债券的远期交易\nB. 债券的即期交易\nC. 质押式回购\nD. 买断式回购",
            "answer": "C",
            "explain": "本题考查债券结算业务类型。质押式回购是交易双方进行的以债券为权利质押的一种短期资金融通业务。质押的国债的所有权仍属于国债的出让方(正回购方)，受让方(逆回购方)无权处置，国债被证券交易中心冻结，债券的所有权没有发生转移，C选项符合题意。债券的远期交易，即期交易和买断式回购的所有权均发生了转移。"
        }, {
            "title": "关于期货交易中的“投机”，以下表述错误的是（　　）。",
            "question": "A. 投机交易增强了市场的流动性\nB. 投机者是使套期保值得以实现的重要力量\nC. 投机者承担风险，不提供风险资产\nD. 承担了套期保值者转移的风险",
            "answer": "C",
            "explain": "本题考查期货市场的基本功能。A、D选项表述正确，投机者是期货市场的重要组成部分，投机交易增强了市场的流动性，承担了套期保值交易转移的风险。B选项表述正确，投机者承担了套期保值交易转移的风险，是套期保值得以实现的重要力量。C选项表述错误，投机者承担了套期保值者转移的风险，并提供(并非不提供)风险资产。"
        },
        {
            "title": "资产A和资产B是两种资产，若他们的收益率相关系数为0.8，关于两者收益率的关系，以下表述正确的是（　　）。",
            "question": "A. 资产A和资产B无线性相关关系\nB. 资产A和资产B之间完全独立\nC. 资产A和资产B负相关\nD. 资产A和资产B正相关",
            "answer": "D",
            "explain": "本题考查相关系数。相关系数总处于+1和-1之间，亦即|p|=1，p=1，表示和完全正相关;p=-1，表示n和完全负相关;p=0，表示两个变量间完全独立，零相关0<|p|< 表示两者不完全相关。本题中，资产A和资产B的收益率相关关系为0.8，则两者收益率正相关。"
        },
        {
            "title": "关于基金管理公司投资管理部门设置，以下表述正确的是（　　）。",
            "question": "A. 投资部是基金投资运作的具体执行部门\nB. 投资决策委员会是基金管理公司的最高决策机构\nC. 研究部负责制定投资及交易策略\nD. 投资部向交易部下达投资指令",
            "answer": "D",
            "explain": "本题考查基金公司投资管理部门设置。A选项表述错误，交易部(并非投资部)是基金投资运作的具体执行部门，负责投资组合交易指令的审核、执行与反馈。B选项表述错误，投资决策委员会是基金管理公司管理基金投资的最高决策机构，由各个基金公司自行设立，是非常设的议事机构。C选项表述错误，研究部是基金投资运作的基础部门，通过对宏观经济形势、行业状况、上市公司等进行详细分析和研究，提出行业资产配置建议并选出具有投资价值的上市公司建立股票池，向基金投资决策部门提供研究报告及投资计划建议。D选项表述正确，投资部负责根据投资决策委员会制定的投资原则和计划制定投资组合的具体方案，向交易部下达投资指令。"
        },
        {
            "title": "债券市场价格越（　　），债券面值，债券期限越（　　），即当期收益率越接近到期收益率。",
            "question": "A. 接近；长\nB. 偏离；长\nC. 偏离；短\nD. 接近；短",
            "answer": "A",
            "explain": "本题考查债券当期收益率与到期收益率之间的关系。当期收益率与到期收益率之间的关系如下：(1)债券市场价格越接近债券面值，期限越长，则其当期收益率就越接近到期收益率(A选项符合题意)；(2)债券市场价格越偏离债券面值，期限越短，则当期收益率就越偏离到期收益率。"
        },
        {
            "title": "对存在活跃市场的投资品种，如估值日无交易，且最近交易日后经济环境发生了重大变化或证券机构发生了影响证券估值的重大事件，使潜在估值调整对基金资产的影响在0.25%以上的，应当参考类似投资品种的现行市价及重大变化因素，调整最近交易市价，确定公允价值，这里的基金资产具体指的是（　　）。",
            "question": "A. 前一估值日的基金资产总值\nB. 当日的基金资产净值\nC. 前一估值日的基金资产净值\nD. 当日的基金资产总值",
            "answer": "C",
            "explain": "本题考查估值的基本原则。对存在活跃市场的投资品种，如估值日无报价的，且最近交易日后经济环境发生了重大变化或证券机构发生了影响证券价格的重大事件，使潜在估值调整对前一估值日的基金资产净值(C选项符合题意)的影响在0.25%以上的，应参考类似投资品种的现行市价及重大变化因素，调整最近交易市价，确定公允价值。"
        },
        {
            "title": "投资者在2017年2月3日（周五）申购A货币基金份额，则该投资者从哪天开始享有A基金的分配权益（　　）。",
            "question": "A. 2017年2月5日（周日）\nB. 2017年2月4日（周六）\nC. 2017年2月3日（周五）\nD. 2017年2月6日（周一）",
            "answer": "D",
            "explain": "本题考查货币市场基金的利润分配。货币市场基金的分配措施为：当日申购的基金份额自下一个工作日起享有基金的分配权益。本题中，该投资者在2017年2月3日（周五）进行申购，则其获得分配收益的时间点为下一个工作日，即2017年2月6日（周一），A选项符合题意。"
        }, {
            "title": "某公募基金的投资范围包括股票、债券和银行存款等，关于该基金投资活动产生的税收，以下表述错误的是（　　）。",
            "question": "A. 卖出股票不征收印花税\nB. 买卖股票、债券取得的差价收入免征增值税\nC. 从证券市场中取得的收入，暂不征收企业所得税\nD. 投资银行存款取得的存款利息不征收增值税",
            "answer": "A",
            "explain": "本题考查基金自身投资活动产生的税收。A选项说法错误，根据财政部、国家税务总局规定，从2008年9月19日起，基金卖出股票时按照1%的税率征收证券(股票)交易印花税，而对买入交易不再征收印花税。"
        },
        {
            "title": "有关交易指令在基金公司内部执行情况的表述，错误的是（　　）。",
            "question": "A. 交易员接收到指令后有权根据自身对市场的判断选择合适时机完成交易\nB. 在自主权限内，基金经理通过交易系统向交易室下达交易指令\nC. 基金经理自行审核投资指令(价格、数量)的合法合规性，违规指令将被拦截，其他指令被分给交易员\nD. 交易员在执行交易的过程中必须严格按照公平公正的原则执行交易",
            "answer": "C",
            "explain": "本题考查执行交易指令。A、D选项表述正确，交易员接收到指令后有权根据自身对市场的判断选择合适时机完成交易。在执行交易过程中必须按照公平公正的原则进行。B选项表述正确，在自主权限内，基金经理通过交易系统向交易室下达交易指令。C选项表述错误，交易系统或相关负责人员(并非基金经理自行)审核投资指令(价格、数量)的合法合规性，违规指令将被拦截，反馈给基金经理，其他指令被分给交易员。"
        },
        {
            "title": "债券的价格与收益率之间是（　　）关系，但该关系式是（　　）。",
            "question": "A. 负相关，非线性的\nB. 负相关，线性的\nC. 正相关，线性的\nD. 相关，非线性的",
            "answer": "A",
            "explain": "本题考查债券的价格与收益率的关系。到期收益率公式为，式中P表示债券市场价格;C表示每期支付的利息;n表示时期数;M表示债券面值。由公式可知，债券价格与收益呈负相关关系，但两者关系式是非线性的。"
        },
        {
            "title": "上交所规定，符合条件的证券公司可以在该所上市的ETF产品提供持续的双边报价服务。关于这些证券公司的角色和功能，以下选项正确的是（　　）。",
            "question": "A. 充当做市商角色，为市场提供流动性\nB. 充当经纪人角色，为市场提供流动性\nC. 充当经纪人角色，执行投资者的指令\nD. 充当做市商角色，执行投资者的指令",
            "answer": "A",
            "explain": "本题考查做市商。做市商通常由具备实力和信誉的证券投资法人承担，本身拥有大量可交易证券，买卖双方均直接与做市商交易，买卖价格则由做市商报出。在报价驱动市场中，做市商是市场流动性的主要提供者与维持者。"
        },
        {
            "title": "相比于股票投资组合，债券投资组合构建时需考虑的特有的因素包括（　　）。",
            "questions": "I. 期限结构<br>II. 标的公司的经营状况<br>III. 宏观经济<br>IV. 组合久期",
            "question": "A. II、III\nB. III、IV\nC. I、IV\nD. I、II",
            "answer": "C",
            "explain": "本题考查债券投资组合构建。不同于股票投资组合，债券投资组合构建还需考虑信用结构、期限结构、组合久期、流动性和杠杆率等因素。"
        },
        {
            "title": "CAPM模型的基本假设不包括（　　）。",
            "question": "A. 所有投资者的投资期限都是相同的\nB. 投资者的投资范围不限于公开市场上可以交易的资产\nC. 所有投资者都是理性的\nD. 所有投资者对于风险的认知都一致",
            "answer": "B",
            "explain": "本题考查资本资产定价模型的前提假设。CAPM基本假定条件：(1)市场上存在大量投资者，每个投资者的财富相对于所有投资者的财富总量而言是微不足道的；(2)所有投资者的投资期限都是相同的，并且不在投资期限内对投资组合做动态的调整;(A选项不符合题意)(3)投资者的投资范围仅限于(并非不限于)公开市场上可以交易的资产，如股票、债券、无风险借贷安排等;(B选项符合题意)(4)不存在交易费用及税金；"
        }, {
            "title": "基金单位资产净值的计算公式为（　　）。",
            "question": "A. NAV=期末基金资产净值+预计发行的基金总份额\nB. NAV=期末基金净资产收益率+预计发行的基金总份额\nC. NAV=期末基金净资产收益率+发行在外的基金总份额\nD. NAV=期末基金资产净值+发行在外的基金总份额",
            "answer": "D",
            "explain": "本题考查基金份额净值的计算公式。基金资产净值除以基金当前的总份额，就是基金份额净值。用公式表达为：NAV=期末基金资产净值/发行在外的基金总份额，D选项符合题意。"
        },
        {
            "title": "关于战略资产配置，以下叙述正确的是（　　）。",
            "question": "A. 战略资产配置结构一旦确定，通常3~5年内再调整各类资产的配置比例\nB. 战略资产配置为了满足投资者风险与收益目标所做的长期资产的配比\nC. 量化模型适用于战术资产配置，不适用于战略资产配置\nD. 基金经理进行战略资产配置时，不能单纯运用经验和判断对资产大类进行甄选",
            "answer": "B",
            "explain": "本题考查战略资产配置与战术资产配置。A选项说法错误，战略资产配置是在一个较长时期内以追求长期回报为目标的资产配置，结构一旦确定，通常情况下在3-5年甚至更长时期内不再调节各类资产的配置比例。B选项说法正确，战略资产配置为了满足投资者风险与收益目标所做的长期资产的配比。"
        },
        {
            "title": "有关证券场内交易的清算与交收规则，以下说法错误的是（　　）。",
            "question": "A. 在境外证券交易所市场，货银对付是普遍的做法，但分级结算原则还没有被普遍应用\nB. 引入共同对手方，可以防范交易对手的信用风险\nC. 场内交易和场外交易的清算和交收规则存在差异\nD. 实行分级结算原则主要是出于规范结算风险的考虑",
            "answer": "A",
            "explain": "本题考查场内证券交易结算原则。A选项说法错误，D选项说法正确，货银对付已经成为各国（地区）证券市场普遍遵循的原则，证券和资金结算实行分级结算原则，实行分级结算原则主要是出于防范结算风险的考虑，在境外证券交易所市场，分级结算是普遍的做法（并非没有被普遍应用）。"
        },
        {
            "title": "不应由基金资产承担的费用是（　　）。",
            "question": "A. 基金合同生效后的会计费用\nB. 基金开户费用\nC. 基金合同生效前的律师费\nD. 基金上市年费",
            "answer": "C",
            "explain": "本题考查基金管理过程中发生的由基金承担的费用。基金管理过程中发生的由基金承担的费用：(1)基金管理人的管理费；(2)基金托管人的托管费。"
        },
        {
            "title": "甲机构持有公司F的优先股，当公司F解散时，财产索取权排在甲机构之后的投资者是（　　）。",
            "question": "A. 公司F的债券持有人\nB. 税务部门\nC. 贷款给公司F的银行\nD. 公司F的普通股持有人",
            "answer": "D",
            "explain": "本题考查各类资本的比较。各类资本的清偿顺序为：(1)债权资本是一种借入资本，代表了公司的合约义务，因此债券持有者/债权人拥有公司资产的最高索取权。"
        },
        {
            "title": "关于风险价值(VaR)的估算方法，以下说法错误的是（　　）。",
            "question": "A. 蒙特卡洛模拟法的计算量较大\nB. 蒙特卡洛模拟法被认为是最精准贴近的计算方法\nC. 参数法假设投资组合中的金融工具是基本风险因子的现行组合\nD. 历史模拟法中优先选用时间间隔较长的历史数据作为数据来源",
            "answer": "D",
            "explain": "本题考查风险价值的估算方法。A、B选项说法正确，蒙特卡洛模拟法在估算之前，需要有风险因子的概率分布模型，继而重复模拟风险因子变动的过程，这种方法虽然计算量较大，但这种方法被认为是最精准贴近的计算VaR值方法。"
        }, {
            "title": "甲、乙、丙、丁四家公司2022年部分财务数据如下表：\n净资产收益率（%） 24% 24% 24% 24%\n销售利润率（%） 4% 6% 6% 8%\n总资产周转率（次） 3 4 2 1\n权益乘数 2 1 2 3\n则四家公司资产使用效率最高的是（　　）。",
            "question": "A. 甲\nB. 乙\nC. 丙\nD. 丁",
            "answer": "A",
            "explain": "本题考查杜邦分析体系。杜邦分析体系将权益回报率分解为销售利润率、资产周转率和权益乘数三个部分，分别反映企业的盈利能力、资产使用效率和财务杠杆水平。根据杜邦分析体系，资产使用效率最高的公司是甲公司。"
        },
        {
            "title": "下列主体中，既是银行间债券市场主管部门，又是银行间债券市场发行主体的是（　　）。",
            "question": "A. 财政部\nB. 中国人民银行\nC. 政策性银行\nD. 金融机构",
            "answer": "B",
            "explain": "本题考查银行间债券市场的组织体系。银行间债券市场主管部门是中国人民银行和中国银行业监督管理委员会，银行间债券市场发行主体包括财政部、中国人民银行、政策性银行、商业银行，以及被批准可以发债的金融类公司、工商企业等。综上所述，中国人民银行既是银行间债券市场主管部门，又具银行间债券市场发行主体，B选项符合题意。"
        },
        {
            "title": "可转换债券价值可以低于（　　）。",
            "question": "A. 与可转换相同期限和票面利率的纯债券价值\nB. 按转换价格和转换比例转股所获得股票的价值\nC. 发行人发行的其他债券的价值\nD. 可转换债券的转换权利价值",
            "answer": "B",
            "explain": "本题考查可转换债券的价值。当按转换价格和转换比例转股所获得股票的价值大于可转换债券的价值时，可转换债券的持有人才会选择可转换债券转换为普通股，B选项符合题意。"
        },
        {
            "title": "关于名义利率，以下说法正确的是（　　）。",
            "question": "A. 名义利率包含了通货膨胀率的变化\nB. 名义利率不会低于实际利率\nC. 名义利率是已设定到期日的零息债券的到期收益率\nD. 名义利率已经剔除了物价的影响",
            "answer": "A",
            "explain": "本题考查名义利率。A选项正确，名义利率包含对通货膨胀率补偿的利率；B选项错误，当物价不断下降，通货膨胀率降低到零以下，名义利率小于实际利率；C选项错误，即期利率是已设定到期日的零息债券的到期收益率；D选项错误，实际利率剔除了物价的影响。"
        },
        {
            "title": "根据GIPS组合群收益率计算的规定，自2006年1月1日起，投资管理机构必须至少（　　）计算一次组合群的收益；自2010年1月1日起，必须至少（　　）计算一次组合群收益。",
            "question": "A. 每月，每季度\nB. 每月，每半年\nC. 每季度，每月\nD. 每季度，每半月",
            "answer": "C",
            "explain": "本题考查GIPS组合群收益率计算的规定。自2006年1月1日起，投资管理机构必须至少每季度一次计算组合群的收益，并使用个别投资组合的收益以资产加权计算。自2010年1月1日起，投资管理机构必须至少每月一次计算组合群收益，并使用个别投资组合的收益以资产加权计算。"
        },
        {
            "title": "基金投资交易执行过程中的风险主要体现在（　　）。",
            "question": "A. 流动性风险\nB. 市场风险\nC. 操作风险\nD. 信用风险",
            "answer": "C",
            "explain": "本题考查操作风险的概念。操作风险是指由于人员、流程、系统或外部因素带来的交易失误，导致基金资产或基金公司财产损失，或基金公司声誉受损、受到监管部门处罚等的风险。A选项不符合题意，流动性风险是指未到期债券的持有者只能以明显低于市值的价格变现债券形成的投资风险，不属于投资交易执行过程中的主要风险。"
        }, {
            "title": "某可转换债券在上海证券交易所上市交易，某日收盘价为109.97元，截止当日日终，每百元面值债券利息为0.08元。当日第三方估值机构对该可转债的估值全价为109.72元。若某基金采用净价对该可转换债券进行估值，应该使用的价格是（　　）。",
            "question": "A. 109.64元\nB. 109.89元\nC. 109.97元\nD. 109.72元",
            "answer": "B",
            "explain": "本题考查交易所上市交易的可转换债券的估值。交易所上市交易的可转换债券当日收盘价作为估值全价。"
        },
        {
            "title": "一般而言，基金公司投资管理部门设置主要包括（　　）。",
            "questions": "I. 投资决策委员会<br>II. 投资部<br>III. 研究部<br>IV. 交易部",
            "question": "A. I、II、III、IV\nB. I、III\nC. II、III\nD. I、II",
            "answer": "A",
            "explain": "本题考查基金管理部门的构成。投资管理是基金管理公司的核心业务，不同基金公司的投资管理部门设置有所差别，但基本包括以下几部分：投资决策委员会、投资部、研究部、交易部。"
        },
        {
            "title": "在持有期为10天，置信水平为99%的情况下，若所计算的风险价值为10万元，则表明该银行的资产组合（　　）。",
            "question": "A. 在10天中的收益有99%的可能性不会超过10万元\nB. 在10天中的收益有99%的可能性会超过10万元\nC. 在10天中的损失有99%的可能性不会超过10万元\nD. 在10天中的损失有99%的可能性会超过10万元",
            "answer": "C",
            "explain": "本题考查风险价值VaR。风险价值是指在给定的时间区间内和给定的置信水平下，利率、汇率等市场风险要素发生变化时，投资组合所面临的潜在最大损失。由于该资产组合的持有期为10天，置信水平为99%，风险价值为10万元，意味着在10天中的损失有99%的可能性不会超过10万元。"
        },
        {
            "title": "截至2018年12月31日，某股票型基金规模18亿元，股票投资总市值10亿元，前十大重仓股票投资总市值3.7亿元，则该基金的持股集中度为（　　）。",
            "question": "A. 50%\nB. 20.56%\nC. 55.56%\nD. 37%",
            "answer": "D",
            "explain": "本题考查股票型基金的风险管理方法。前十大重仓股占比是衡量持股集中度的常用指标，其计算方法如下：持股集中度=（前十大重仓股投资市值/基金股票投资总市值）×100%=（3.7/10）×100%=37%。"
        },
        {
            "title": "股票拆分对（　　）没有影响。",
            "question": "A. 每股盈余\nB. 股票价格\nC. 每股面值\nD. 股东权益总额",
            "answer": "D",
            "explain": "本题考查股票拆分的影响。股票拆分的影响：（1）会使发行在外的股票总数增加；（2）每股面值降低，并由此引起每股收益和每股市价的下降(A、B、C选项不符合题意)；（3）股东的持股比例和权益总额及其各项权益余额都保持不变；（4）对公司的资本结构和股东权益不会产生任何影响。(D选项符合题意)"
        },
        {
            "title": "基金业绩评价需要考虑的因素不包括（　　）。",
            "question": "A. 基金管理规模\nB. 综合考虑风险和收益\nC. 时间区间\nD. 基金的管理费费率",
            "answer": "D",
            "explain": "本题考查基金业绩评价应考虑的因素。基金业绩评价需要考虑的因素：基金管理规模；时间区间；综合考虑风险和收益。"
        }, {
            "title": "绝对收益归因提供了参考（　　）的直观方式。",
            "question": "A. 基金资产配置效果\nB. 行业和证券收益贡献\nC. 不同投资策略收益\nD. 基金投资组合分类选择",
            "answer": "B",
            "explain": "本题考查绝对收益归因的概念。绝对收益归因是考察各个因素对基金总收益的贡献，其本质是对基金总收益的分解，其提供了一个考察证券和行业收益的直观方式。"
        },
        {
            "title": "关于股票型基金，以下表述错误的是（　　）。",
            "question": "A. 若服从正态分布，则基金收益率落入平均值左右2个标准差范围内的概率是96%\nB. 基金收益率波动程度越小，基金的风险越低\nC. 分散投资不能降低投资的系统性风险\nD. 通常按月计算基金收益率的波动程度，衡量标准可以选择标准差",
            "answer": "A",
            "explain": "本题考查股票基金的风险指标。在净值增长率服从正态分布时，则基金收益率落入平均值左右2个标准差范围内的概率是95%，A选项表述错误。"
        },
        {
            "title": "关于场内证券交易成本，以下表述错误的是（　　）。",
            "question": "A. 佣金是指交易成功后，投资者根据交易笔数付给经纪人的费用\nB. 印花税是根据国家税法规定，在股票成交后对买卖双方投资者按照规定的税率分别征收的税金\nC. 证券公司对于不同的投资者往往会采用不同的交易佣金费率\nD. 在证券交易结束后还需要支付给证券登记结算机构一定费用，这部分费用称为过户费",
            "answer": "A",
            "explain": "本题考查场内证券交易与结算涉及的费用。佣金是投资者在委托买卖证券成交后按成交金额（并非交易笔数）的一定比例支付的费用，是证券经纪商为客户提供证券代理买卖服务收取的费用。A选项说法错误。"
        },
        {
            "title": "关于基金利润分配，以下表述正确的是（　　）。",
            "question": "A. 封闭式基金进行利润分配，投资者可以选择分红再投资方式\nB. 基金进行利润分配后，份额净值可能低于面值\nC. 基金进行利润分配前，份额净值可能低于面值\nD. 基金进行利润分配后，份额净值不得低于面值",
            "answer": "D",
            "explain": "本题考查基金利润分配。A、B选项说法错误，基金进行利润分配时，对于封闭式基金，只能采用现金分红；对于开放式基金，投资者可以选择现金分红或分红再投资。C选项说法错误，基金进行利润分配前，份额净值不得低于面值。D选项说法正确，基金进行利润分配后，份额净值不得低于面值。"
        },
        {
            "title": "关于股票价格，以下表述错误的是（　　）。",
            "question": "A. 股票之所以有价格，是因为它能给它的持有者带来股息红利\nB. 股票交易实际上是对未来收益权的买卖\nC. 股票的理论价格，是以一定利率计算出来的未来收入的现值\nD. 股票价格完全由供求关系决定",
            "answer": "D",
            "explain": "本题考查股票的价值与价格。股票的市场价格一般是假定股票在二级市场上买卖的价格。供求关系是最直接的影响因素，其他因素都是通过作用于供求关系而影响股票价格的，D选项表述错误。"
        },
        {
            "title": "证券投资基金进行场内证券交易，除需向券商支付佣金外，还需要支付的交易成本包含（　　）。",
            "question": "A. 过户费、销售费、证管费\nB. 过户费、托管费、证管费\nC. 过户费、经手费、印花税\nD. 印花税、交易单元流量费、证管费",
            "answer": "C",
            "explain": "本题考查场内证券交易与结算涉及的费用。基金通过与券商签订交易单元租用合同，获得投资交易的路径。基金需要向券商支付交易佣金，还需要支付过户费、经手费、证管费、印花税等交易成本。"
        },
        {
            "title": "基金季度报告的持仓集中度分析通常计算持仓的前（　　）只股票占基金净值的比例。",
            "question": "A. 10\nB. 30\nC. 5\nD. 20",
            "answer": "A",
            "explain": "本题考查持仓集中度分析的概念。持仓集中度分析是指通过计算前10只股票投资市场占基金净值的比例可以分析基金是否倾向于集中投资，A选项符合题意。"
        },
        {
            "title": "用某一时期内投资组合平均超额收益除以这个时期收益的标准差的是（　　）。",
            "question": "A. 靠着比率\nB. 特香诺比率\nC. 信息比率\nD. 夏普比率",
            "answer": "D",
            "explain": "本题考查夏普比率。夏普比率是诺贝尔经济学奖得主威廉夏普善于19666年根据资本资产定价模型（CAPM）提出的经风险调整的业绩衡量指标。此比率是用某一时期内投资组合平均超额收益除以这个时期收益的标准差。"
        }, {
            "title": "已知某公司的净资产收益率是10%，销售利润率是10%，权益乘数是2，年平均总资产是1000万元，该公司的年销售收入是（　　）。",
            "question": "A. 500万元\nB. 1000万元\nC. 100万元\nD. 2000万元",
            "answer": "A",
            "explain": "本题考查年销售收入的计算。净资产收益率=销售利润率×权益乘数×总资产周转率；总资产周转率=年销售收入/年均总资产。将题中数值代入公式计算得出年销售收入=50%×1000=500万元。"
        },
        {
            "title": "以下有关信用风险管理的主要措施说法错误的是（　　）。",
            "question": "A. 建立针对债券发行人的内部信用评级制度，进行发行人信用风险管理\nB. 建立严格的信用风险监控体系，对信用风险及时发现、汇报和处理\nC. 由于交易对手的信用资质一般变化不大，因此根据交易对手的资质、交易记录、信用记录和交收违约记录等因素进行信用评级之\nD. 建立交易对手信用评级制度",
            "answer": "C",
            "explain": "本题考查信用风险的管理措施。A选项说法正确，建立针对债券发行人的内部信用评级制度，并且结合外部的信用评级，进行发行人信用风险的管理。B选项说法正确，建立严格的信用风险监控体系，对信用风险及时发现、汇报和处理。C选项说法错误，交易对手的信用资质一般变化不大，因此根据交易对手的资质、交易记录、信用记录和交收违约记录等因素进行信用评级之，可能不准确。D选项说法正确，建立交易对手信用评级制度。"
        },
        {
            "title": "关于私募股权投资的J曲线以下表述错误的是（　　）。",
            "question": "A. J曲线意味着私募股权投资的收益率通常早期较高，之后逐年走低\nB. 私募股权基金在其投资项目的早期阶段，净现金流为负数\nC. J曲线反映私募股权投资的收益率，随时间变化的轨迹\nD. J曲线是因为其轨迹与字母J相似而得名",
            "answer": "A",
            "explain": "本题考查J曲线。对于投资者而言，J曲线意味着私募股权投资通常并不是在一两年内就能得到满意回报，因此早期收益率较低，之后逐年增加。"
        },
        {
            "title": "QDII基金，以下行为无需中国证监会另行规定的是（　　）。",
            "question": "A. 购买不动产\nB. 购买实物商品\nC. 从事证券承销业务\nD. 投资政府债券",
            "answer": "D",
            "explain": "本题考查QDII基金的投资范围。A、B、C选项均属于QDII基金禁止投资的范围，如有需要，则需证监会另行规定，不符合题意。D选项中的政府债券，属于QDII基金可投资的范围，无需证监会另行规定，符合题意。"
        },
        {
            "title": "关于基金利润分配，以下表述正确的是（　　）。",
            "question": "A. 封闭式基金的利润分配比例不得高于基金年度可供分配利润的90%\nB. 开放式基金利润分配有两种分配方式，如投资者事先没有做出选择，默认为采取分红再投资方式\nC. 基金进行利润分配会导致基金份额净值的下降，但不会影响到投资者的实际利益\nD. 封闭式基金收益分配后基金份额净值不得高于面值",
            "answer": "C",
            "explain": "本题考查基金利润分配。A选项表述错误，封闭式基金年度收益分配比例不得低于(并非不得高于)基金年度可供分配利润的90%。B选项表述错误，开放式基金可采用现金分红方式和分红再投资方式，基金收益分配默认为采用现金方式，持有人可以事先选择分红再投资，事先没有做出选择的，基金管理人应当支付现金。"
        },
        {
            "title": "在资本市场理论前提假设中，关于资金借入与贷出的说法正确的是（　　）。",
            "question": "A. 投资者可以以无风险利率借入资金\nB. 银行货币供应量影响投资者借入或贷出资金的限额\nC. 个人财富影响投资者借入或贷出资金的限额\nD. 投资者贷出资金的利率高于借入资金的利率",
            "answer": "A",
            "explain": "本题考查资本市场理论的前提假设。投资者可以以无风险利率任意地借入资金或者贷出资金。银行货币供应量、个人财富不会影响投资者借入或贷出资金的限额。综上所述，A选项符合题意。"
        }, {
            "title": "证券m与n之间的相关系数为-0.5，以下说法正确的是（　　）。",
            "question": "A. m与n正相关\nB. m与n不相关\nC. m与n的相关性无法判断\nD. m与n负相关",
            "answer": "D",
            "explain": "本题考查相关系数。相关系数是从资产回报相关性的角度分析两种不同证券表现的联动性。相关系数ρj总处于+1和-1之间，亦即|ρj|≤1。(1)ρj=1，表示ρj和ρj完全正相关；(2)ρj=-1，表示ρj和ρj完全负相关；(3)ρj=0，表示两个变量间完全独立，零相关；(4)0<|ρj|<1，表示两者不完全相关。证券m与n之间的相关系数为-0.5，则m与n负相关。"
        },
        {
            "title": "资本资产定价模型(CAPM)用希腊数字贝塔(β)来描述资产或资产组合的系统风险，则关于β系数的表述，正确的是（　　）。",
            "question": "A. 贝塔值越大，预期收益率越低\nB. 贝塔可以理解为某资产或资产组合对市场收益变动的敏感性\nC. 贝塔值不能小于0\nD. 市场组合的贝塔值为0",
            "answer": "B",
            "explain": "本题考查贝塔系数。A选项表述错误，贝塔值越大，说明资产或资产组合的系统风险越大，则资产或资产组合的预期收益率越高(并非越低)。B选项表述正确，CAPM利用希腊字母贝塔(β)来描述资产或资产组合的系统风险大小，贝塔(β)可以理解为某资产或资产组合对市场收益变动的敏感性。C选项表述错误，贝塔系数小于0时，该投资组合的价格变动方向与市场相反，贝塔值可以(并非不能)小于0。D选项表述错误，市场组合的贝塔值为1(并非为0)。"
        },
        {
            "title": "票面金额为100元的3年期债券，票面利率5%，每年付息一次，当前市场价格为90元，则该债券的到期收益率为（　　）。",
            "question": "A. 5.0556%\nB. 5%\nC. 8.9468%\nD. 1.7235%",
            "answer": "C",
            "explain": "本题考查到期收益率的计算。到期收益率用y表示，90=5/(1+y)+5/(1+y)^2+105/(1+y)^3，y=8.9468%。"
        },
        {
            "title": "以下衍生工具中买卖双方只有一方在未来有义务，被称作单边合约的是（　　）。",
            "questions": "I. 远期合约<br>II. 期货合约<br>III. 期权合约<br>IV. 信用互换合约",
            "question": "A. I、IV\nB. III、IV\nC. II、III\nD. I、II",
            "answer": "B",
            "explain": "本题考查远期合约、期货合约、期权合约和互换合约的区别。I、II项不符合题意，远期合约、期货合约和大部分互换合约都包括买卖双方在未来应尽的义务，被称作远期承诺或者双边合约。III、IV项符合题意，期权合约和信用互换合约只有一方在未来有义务，被称作单边合约。"
        },
        {
            "title": "某企业2016年度的销售利润率为10%，年销售收入为10亿元，年均总资产为50亿元，权益乘数为200%，则该企业2016年度的净资产收益率为（　　）。",
            "question": "A. 4%\nB. 100%\nC. 2%\nD. 8%",
            "answer": "A",
            "explain": "本题考查杜邦恒等式。本题涉及公式包括：（1）总资产周转率=年销售收入/年均总资产；（2）净资产收益率=销售利润率×总资产周转率×权益乘数。本题中，销售利润率为10%，年销售收入为10亿元，年均总资产为50亿元，权益乘数为200%。将数值代入公式（1）得总资产周转率=10/50=20%，则净资产收益率=10%×20%×200%=4%。"
        },
        {
            "title": "根据人民银行规定，债券质押式回购最长期限不得超过（　　）。",
            "question": "A. 1年\nB. 3年\nC. 2年\nD. 5年",
            "answer": "A",
            "explain": "本题考查质押式回购的期限。质押式回购业务是指交易双方进行的以债券为权利质押的一种短期资金融通业务。质押式回购期限最长为1年，在1年之内由投资者双方自行商定回购期限，A选项符合题意。"
        }, {
            "title": "自上而下股票投资策略在实际应用中，不包括（　　）。",
            "question": "A. 根据宏观经济研究决定大类资产配置\nB. 从周期非敏感型行业转换为周期敏感型行业，从而获得板块的差额收益\nC. 运用基本面分析深入研究个股的投资价值\nD. 转换价值股和成长股的投资比例，追求风格收益",
            "answer": "C",
            "explain": "本题考查自上而下股票投资策略。自上而下策略从宏观形势及行业、板块特征入手，明确大类资产、国家、行业的配置，然后再挑选相应的股票作为投资标的，实现配置目标。A选项不符合题意，根据宏观经济研究决定大类资产配置为自上而下股票投资策略在实际应用中。B选项不符合题意，从周期非敏感型行业转换为周期敏感型行业，从而获得板块的差额收益是从板块特征入手实现配置目标，为自上而下股票投资策略在实际中的应用。"
        },
        {
            "title": "投资管理过程是一个动态循环过程，整个过程包含三个步骤，但不包括（　　）。",
            "question": "A. 执行\nB. 规划\nC. 反馈\nD. 检验",
            "answer": "D",
            "explain": "本题考查投资管理的过程。CFA协会将投资管理过程定义为一个动态反馈的循环过程，整个流程可以划分为规划、执行和反馈三个基本步骤。D选项中的检验不包括在其中，符合题意。"
        },
        {
            "title": "关于基金的业绩比较基准，以下表述错误的是（　　）。",
            "question": "A. 基金业绩比较基准是衡量基金相对收益的重要指标\nB. 基金业绩比较基准的选取服从于投资范围\nC. 基金业绩比较基准选择的都是各类市场指数",
            "answer": "D",
            "explain": "本题考查基金的业绩比较基准。A、C选项表述正确，所有的基金都需要选定一个业绩比较基准，业绩比较基准不仅是考核基金业绩的工具，是衡量基金相对收益的重要指标，也是投资经理进行组合构建的出发点，可以为基金经理投资管理提供指引。B选项表述正确，D选项表述错误。指数基金的业绩比较基准就是其跟踪的指数本身，其他类型的基金在选择业绩比较基准时，需要充分考虑其投资目标、投资范围的影响。综上所述，A、B、C选项表述正确，D选项表述错误。"
        },
        {
            "title": "如果证券价格中已经反映了影响价格的全部信息，那么该证券市场被称为（　　）。",
            "question": "A. 强有效市场\nB. 都有效市场\nC. 半强有效市场\nD. 无效市场",
            "answer": "A",
            "explain": "本题考查强有效市场的特征。有效市场分为三种不同类型：一是弱有效市场，认为股价已反映了全部能从市场交易数据中得到的信息；二是半强有效市场，认为股价已反映了所有公开的信息；三是强有效市场，指股价已反映了全部与公司有关的信息，包括所有公开信息及内部信息。"
        },
        {
            "title": "关于基金计价，下列何种机构制定基金估值和份额净值计价的业务管理制度，明确基金估值的程序和技术（　　）。",
            "question": "A. 基金经理\nB. 基金管理人\nC. 基金托管人\nD. 其他三项都是",
            "answer": "B",
            "explain": "本题考查估值责任人。A选项不符合题意，在实际操作中，基金经理负责投资决策的制定。B选项符合题意，基金管理人是我国基金资产估值的责任人，需要制定基金估值和份额净值计价的业务管理制度，明确基金估值的程序和技术。C选项不符合题意，基金托管人是根据法律法规的要求，在证券投资基金运作中承担资产保管、交易监督、信息披露、资金清算与会计核算等相应职责的当事人。"
        },
        {
            "title": "通常，股票型指数基金与所跟踪指数会存在一定的跟踪误差，以下属于跟踪误差产生原因的是（　　）。",
            "questions": "I. 指数成分股流动性不足，导致无法完全复制<br>II. 由于有现金留存，导致投资组合不能全部投资于标的指数<br>III. 运营基金，复制指数时存在成本费用<br>IV. 基金进行证券交易时可能存在冲击成本",
            "question": "A. I、III\nB. I、II、III、IV\nC. I、II\nD. II、III、IV",
            "answer": "B",
            "explain": "本题考查跟踪误差产生的原因。I项说法正确，指数成分股流动性不足，导致无法完全复制；II项说法正确，由于有现金留存，导致投资组合不能全部投资于标的指数；III项说法正确，运营基金，复制指数时存在成本费用；IV项说法正确，基金进行证券交易时可能存在冲击成本。综上所述，B选项符合题意。"
        },
        {
            "title": "关于基金业绩评价需要考虑的因素不包括（　　）。",
            "question": "A. 基金管理规模\nB. 综合考虑风险和收益\nC. 时间区间\nD. 基金的管理费费率",
            "answer": "D",
            "explain": "本题考查基金业绩评价应考虑的因素。基金业绩评价需要考虑的因素：基金管理规模；时间区间；综合考虑风险和收益。"
        }, {
            "title": "下列关于可赎回债券的表述中，错误的是（　　）。",
            "question": "A. 可赎回债券的赎回条款是发行人的权利，对债权人不利\nB. 可赎回债券赋予发行人看涨期权的价值\nC. 可赎回债券的赎回价格可以是固定的，也可以是浮动的\nD. 与一个其他属性相同但没有赎回条款的债券相比，可赎回债券的利息更低",
            "answer": "D",
            "explain": "本题考查可赎回债券。A选项说法正确，D选项说法错误，赎回条款是发行人的权利而非持有者，换句话说，是保护债务人而不是债权人的条款，对债权人不利。因此，和一个其他属性相同但是没有赎回条款的债券相比，可赎回债券的利息更高(并非更低)，以补偿债券持有者面临的债券赎回风险。B选项说法正确，可赎回债券为发行人提供在债券到期前的特定时段以事先约定价格买回债券的权利，通常约定发行一段时间后才可执行即赋予发行人看涨期权的价值。"
        },
        {
            "title": "假定某投资组合收益与市场收益的协方差为正且保持不变，当市场收益的标准差增加时，根据贝塔公式，该投资组合贝塔系数将（　　）。",
            "question": "A. 先增后减\nB. 减小\nC. 增加\nD. 不变",
            "answer": "B",
            "explain": "本题考查贝塔系数的计算公式。根据公式：β=Cov/σ^2，其中Cov表示协方差，如果当Cov不变，当σ上升时，β下降。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/jjjc-3.js